import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import arrowDown from "assets/images/arrow-down-circle.svg";
import Loading from "components/loading/Loading";
import Axios from "middleware/axiosInstance";
import { Rating } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import { withStyles } from "@material-ui/core/styles";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import classes from "./UserRate.module.scss";
const UserRate = () => {
  const [userScore, setUserScore] = useState(null);

  // start MUI Accordion
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  // end MUI Accordion

  const getUserScore = () => {
    Axios.get("show_score").then((res) => {
      setUserScore(res.data);
    });
  };

  useEffect(() => {
    getUserScore();
  }, []);

  const emoji = (score) => {
    console.log("intered");
    const level = score.score / 20;
    console.log(level);
    switch (level) {
      case 0:
      case 1:
        <SentimentVeryDissatisfiedIcon
          style={{ color: "deepOrange", fontSize: 30 }}
        />;
      case 2:
        return (
          <SentimentDissatisfiedIcon
            style={{ color: "orange", fontSize: 30 }}
          />
        );
      case 3:
        return (
          <SentimentSatisfiedIcon
            fontSize="large"
            style={{ color: "lime", fontSize: 30 }}
          />
        );
      case 4:
        return (
          <SentimentSatisfiedAltIcon
            style={{ color: "lightGreen", fontSize: 30 }}
          />
        );
      case 5:
        return (
          <SentimentVerySatisfiedIcon
            style={{ color: "green", fontSize: 30 }}
          />
        );
      default:
        return <p>{level}</p>;
    }
  };

  return (
    <div
      className={`d-flex align-items-center flex-column position-relative TabBar-container ${classes.userRateContainer}`}
    >
      <h2 className="mt-3">امتیازات شما</h2>
      {userScore ? (
        userScore.length === 0 ? (
          <div>امتیازی ثبت نشده است</div>
        ) : (
          <div className="page-content-overflow-scroll">
            {userScore.map((score, index) => {
              return (
                <Accordion
                  className="mt-4"
                  expanded={expanded === `panel${index + 1}`}
                  onChange={handleChange(`panel${index + 1}`)}
                >
                  <AccordionSummary
                    // expandIcon={<img src={arrowDown} width="30" height="30" />}
                    aria-controls={`panel${index + 1}bh-content`}
                    id={`panel${index + 1}bh-header`}
                  >
                    <Typography
                      sx={{ width: "130px", flexShrink: 0, flexWrap: "wrap" }}
                    >
                      {` ${score.month} ${score.year}`}
                    </Typography>
                    <Typography
                      className={`${classes.MuiDisabled}`}
                      // sx={{ color: "text.secondary" }}
                    >
                      {/* <Rating
                        disabled
                        name="customized-icons"
                        defaultValue={parseInt(score.score) / 20}
                        getLabelText={(value) => customIcons[value].label}
                        IconContainerComponent={IconContainer}
                        // className={classes.blue}
                      /> */}
                      {emoji(score)}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div>
                      <table>
                        <thead>
                          <td>عنوان</td>
                          <td>امتیاز</td>
                        </thead>
                        {score.items?.map((item) => {
                          return (
                            <tr>
                              <td>{item.name}</td>
                              <td>{item.value}</td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
        )
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default UserRate;